import { getOwnConfig, macroCondition } from '@embroider/macros';
import EmbroiderRouter from '@embroider/router';
import config from 'walden-fast/config/environment';
import type { FeatureFlag } from './services/feature-flags';
import { service } from '@ember/service';
import type FeatureFlagsService from './services/feature-flags';
import type Transition from '@ember/routing/transition';
import type { OwnBuildConfig } from 'walden-fast/types';

export default class Router extends EmbroiderRouter {
  location = config.locationType;
  rootURL = config.rootURL;

  @service('feature-flags') declare featureFlags: FeatureFlagsService;

  constructor() {
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);

    this.on('routeWillChange', (transition: Transition) => {
      void this.checkFeatureFlagForRoute(transition);
    });
  }

  async checkFeatureFlagForRoute(transition: Transition) {
    const routeName = transition.to?.name;

    if (!routeName) {
      return;
    }

    if (FEATURE_FLAG_ROUTES[routeName]) {
      if (
        !(await this.featureFlags.anyEnabled(FEATURE_FLAG_ROUTES[routeName]))
      ) {
        this.transitionTo('/not-found', '');
      }
    }
  }
}

const FEATURE_FLAG_ROUTES: Record<string, FeatureFlag[]> = {
  'app.dashboard': ['WALDEN_DASHBOARD'],
  'app.contact.chat': ['WALDEN_CHAT'],
  'app.contact.index': ['WALDEN_TICKETS'],
  'app.walden-view': [
    'WALDEN_VIEW_INBOUND_OUTBOUND',
    'WALDEN_VIEW_INVENTORY',
    'WALDEN_VIEW_ORDER_DETAILS',
    'WALDEN_VIEW_MASTER_DATA',
    'WALDEN_VIEW_TRANSPORT',
    'WALDEN_VIEW_ORDER_TRACKING',
    'WALDEN_VIEW_ORDER_2_CASH',
  ],
  'app.services.walden-view-ref': [
    'WALDEN_SERVICE_ML',
    'WALDEN_SERVICE_ORCHESTRATION',
  ],
  'app.services.walden-green': ['WALDEN_SERVICE_GREEN'],
  'app.services.walden-pulse': ['WALDEN_SERVICE_PULSE'],
  'app.services.walden-trace': ['WALDEN_SERVICE_TRACE'],
  'app.services.walden-vas': ['WALDEN_SERVICE_VAS'],
  'app.services.walden-box': ['WALDEN_SERVICE_BOX'],
  'app.services.walden-connect': ['WALDEN_SERVICE_CONNECT'],
  'app.manage.subscriptions.services': ['WALDEN_MANAGE_SUBSCRIPTIONS'],
  'app.manage.subscriptions.invoices': ['WALDEN_MANAGE_SUBSCRIPTIONS'],
  'app.manage.organisation': ['WALDEN_MANAGE_ORGANISATIONS'],
};

Router.map(function () {
  this.route('auth-callback');
  this.route('app', { path: '/' }, function () {
    this.route('dashboard');

    this.route('walden-view', { path: '/walden-view/:report' }, function () {
      this.route('detail', { path: '/:page' });
    });

    this.route('services', function () {
      this.route('walden-view-ref', { path: '/:report' }, function () {
        this.route('detail', { path: '/:page' });
      });
      this.route('walden-green', function () {
        this.route('overview');
      });
      this.route('walden-trace', { path: '/walden-trace/:carrier' });
      this.route('walden-box', function () {
        this.route('list');
        this.route('map');
        this.route('detail', { path: '/:shipment_id' });
      });
      this.route('walden-connect', function () {
        this.route('client', { path: '/:client_name_local' });
      });
      this.route('walden-pulse');
      this.route('walden-vas');
    });

    this.route('manage', function () {
      this.route('organisation');
      this.route('subscriptions', function () {
        this.route('services');
        this.route('invoices');
      });
    });

    this.route('user', function () {
      this.route('profile');
    });

    this.route('contact', function () {
      this.route('submit-ticket');
      this.route('chat');
    });
  });
  this.route('unauthorized');

  if (macroCondition(getOwnConfig<OwnBuildConfig>().styleGuideIncluded)) {
    this.route('style-guide');
  }
  this.route('not-found', { path: '/*path' });
});
